export const CLEAR_RENDER_FROM = 'CLEAR_RENDER_FROM';
export const GET_CERTONA_ATTRIBUTES = 'GET_CERTONA_ATTRIBUTES';
export const GET_ITEM_DELIVERY_SUMMARY = 'GET_ITEM_DELIVERY_SUMMARY';
export const GET_ORDER_ADJUSTMENTS = 'GET_ORDER_ADJUSTMENTS';
export const GET_ORDER_BILLING_INFO = 'GET_ORDER_BILLING_INFO';
export const GET_ORDER_CHARGES = 'GET_ORDER_CHARGES';
export const GET_ORDER_CONTACT_INFO = 'GET_ORDER_CONTACT_INFO';
export const GET_ORDER_GIFT_WRAP_INFO = 'GET_ORDER_GIFT_WRAP_INFO';
export const GET_ORDER_INFO = 'GET_ORDER_INFO';
export const GET_ORDER_ITEMS = 'GET_ORDER_ITEMS';
export const GET_ORDER_PAYMENT_INFO = 'GET_ORDER_PAYMENT_INFO';
export const GET_ORDER_SHIPPING_GROUPS_INFO = 'GET_ORDER_SHIPPING_GROUPS_INFO';
export const GET_ORDER_TOTALS = 'GET_ORDER_TOTALS';
export const GET_STORE_INFO_REQUEST = 'GET_STORE_INFO';
export const GET_STORE_INFO_SUCCESS = 'GET_STORE_INFO_SUCCESS';
export const LAST_ORDER_GET_REQUEST_SUCCESS = 'LAST_ORDER_GET_REQUEST_SUCCESS';
export const LAST_ORDER_NOT_FOUND = 'LAST_ORDER_NOT_FOUND';
export const ORDER_INFO_INLINE_LOADER = 'ORDER_INFO_INLINE_LOADER';
export const UPDATE_ITEM_COUNT = 'UPDATE_ITEM_COUNT';
